'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var bonuses = require('./bonuses.js');
var competitions = require('./competitions.js');
var users = require('./users.js');
var games = require('./games.js');
var configs = require('./configs.js');
var wallet = require('./wallet.js');
var translations = require('./translations.js');
var promotions = require('./promotions.js');
var pages = require('./pages.js');
var signup = require('./signup.js');
var maintenance = require('./maintenance.js');
var messages = require('./messages.js');
var navigations = require('./navigations.js');
var offers = require('./offers.js');
var responsibleGaming = require('./responsibleGaming.js');
var faqs = require('./faqs.js');
var faqsCategories = require('./faqsCategories.js');
var system = require('./system.js');
var rewards = require('./rewards.js');
var lottery = require('./lottery.js');
var loyalty = require('./loyalty.js');
var sitefeatures = require('./sitefeatures.js');
var gamification = require('./gamification.js');
var geoComply = require('./geoComply.js');
var externalServices = require('./externalServices.js');



exports.bonuses = bonuses.bonuses;
exports.competitions = competitions.competitions;
exports.users = users.users;
Object.defineProperty(exports, 'Device', {
	enumerable: true,
	get: function () {
		return games.Device;
	}
});
exports.games = games.games;
exports.getGameCategories = games.getGameCategories;
exports.getGameCategory = games.getGameCategory;
exports.configs = configs.configs;
exports.wallet = wallet.wallet;
exports.translations = translations.translations;
exports.promotions = promotions.promotions;
exports.pages = pages.pages;
exports.signup = signup.signup;
exports.maintenance = maintenance.maintenance;
exports.messages = messages.messages;
exports.navigations = navigations.navigations;
exports.offers = offers.offers;
exports.responsibleGaming = responsibleGaming.responsibleGaming;
exports.faqs = faqs.faqs;
exports.faqsCategories = faqsCategories.faqsCategories;
exports.system = system.system;
exports.rewards = rewards.rewards;
exports.lottery = lottery.lottery;
exports.loyalty = loyalty.loyalty;
exports.sitefeatures = sitefeatures.sitefeatures;
exports.gamification = gamification.gamification;
exports.geoComply = geoComply.geoComply;
exports.externalServices = externalServices.externalServices;
